export default __webpack_public_path__ + "static/media/about.8b7de022.png";